import React, { useContext } from 'react';
import Grid from '@mui/material/Grid';

import CompressorDetailsSection from './CompressorDetailsSection';
import { ChillerLogsContext } from '../contexts/ChillerLogsContext';

const AllCircuitCompressorsSection: React.FunctionComponent = () => {
  const { chillerLog } = useContext(ChillerLogsContext);

  const circuitsToDisplay = chillerLog?.circuits?.slice(0, chillerLog?.circuit_count);

  return (
    <Grid container>{circuitsToDisplay?.map((circuit, index) => <CompressorDetailsSection circuit={circuit} />)}</Grid>
  );
};

export default AllCircuitCompressorsSection;
